"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
import { Star, Award, CircleCheck as CheckCircle, ShieldCheck, Gem, Heart } from 'lucide-react';
export default function Whyshopwithlush() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pressMentions = [{
    publication: "Vogue Style",
    citation: "Top Fashion Pick",
    icon: Star
  }, {
    publication: "Elle Weekly",
    citation: "Trendsetter Award",
    icon: Award
  }, {
    publication: "Harper's Bazaar",
    citation: "Editor's Choice",
    icon: CheckCircle
  }, {
    publication: "Fashion Daily",
    citation: "Best New Brand",
    icon: ShieldCheck
  }, {
    publication: "Style Insider",
    citation: "Premium Quality",
    icon: Gem
  }, {
    publication: "Glamour Hub",
    citation: "Customer Favorite",
    icon: Heart
  }];
  return <section data-section-id="1901" id="whyshopwithlush" className="bg-white text-foreground py-32 border-t border-border">
      <div ref={ref} className={`mx-auto max-w-7xl px-6 md:px-10 lg:px-16 transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="flex flex-col items-center text-center">
          <h3 className="heading uppercase text-foreground" style={{
          fontSize: "1.75rem",
          letterSpacing: "0.16em",
          lineHeight: 1.2
        }}>
            § 02 — Why Shop With Lush
          </h3>

          <div className="mt-6 flex items-center justify-center" style={{
          width: "140px"
        }}>
            <div className="h-px flex-1 bg-border" />
            <span className="inline-block bg-accent" style={{
            width: "6px",
            height: "6px",
            borderRadius: "4px"
          }} aria-hidden="true" />
          </div>
        </div>

        <div className="mt-12 md:mt-16 grid grid-cols-1 md:grid-cols-4 gap-6">
          {pressMentions.map((mark, i) => <Card data-index={i} key={i} className="p-6 flex flex-col items-start md:items-center justify-center text-left md:text-center group cursor-default border-none shadow-md hover:shadow-lg transition-shadow duration-300">
              <mark.icon className="text-accent mb-4" size={24} strokeWidth={1.25} />
              <p className="body text-foreground leading-snug" style={{
            fontSize: "14px"
          }}>
                <span className="font-semibold group-hover:underline group-hover:decoration-accent group-hover:decoration-1 group-hover:underline-offset-4 transition-all duration-200">
                  {mark.publication}
                </span>
                <span className="mx-1.5 text-muted-foreground">—</span>
                <span className="group-hover:underline group-hover:decoration-accent group-hover:decoration-1 group-hover:underline-offset-4 transition-all duration-200">
                  {mark.citation}
                </span>
              </p>
            </Card>)}
        </div>

        <div className="mt-10 flex justify-center">
          <p className="body italic text-muted-foreground text-center" style={{
          fontSize: "12px"
        }}>
            join thousands of satisfied fashion enthusiasts worldwide
          </p>
        </div>
      </div>
    </section>;
}